export enum SupportedProviders {
  UberEats = 'UberEats',
  SocialFood = 'SocialFood',
  Glovo = 'Glovo', 
  Bolt = 'Bolt',
  Wolt = 'Wolt',
  JustEat = 'JustEat'
}
